// extracted by mini-css-extract-plugin
export default {"activityItem":"ActivityItem_activityItem__y8gZ2","icon":"ActivityItem_icon__gNZkV","value":"ActivityItem_value__OWsIU","label":"ActivityItem_label__3po5R"};